import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Navigate,
  Routes
} from "react-router-dom";
import {useSelector} from "react-redux";

import ScrollToTop from './components/ScrollToTop';
import Dashboard from 'pages/Dashboard';
import Footer from 'components/Footer';
import DoctorProfile from './pages/doctor/components/doctorProfile/DoctorProfile';
import Doctor from './pages/doctor/Doctor';
import {Notification} from './pages/notification/Notification';
import Consultation from './pages/consultation/Consultation';
import PromotionalEvent from './pages/event/PromotionalEvent';
import Pharmacist from './pages/pharmacist/Pharmacist';
import FocusItems from './pages/focusItems/FocusItems';
import PaymentVerification from './pages/paymentVerification/PaymentVerification';
import RemoteConfig from './pages/remoteConfig/RemoteConfig';
import DynamicUiPage from 'pages/dynamicUi';
import NurseCampaign from './pages/nuseCampaign/NurseCampaign';
import CampaignJobs from './pages/nuseCampaign/components/CampaignsJobs';
import Shifts from './pages/shifts/Shifts';
import Sidebar from "./components/Sidebar";
import CampaignReport from "./pages/campaignReporting/CampaignReport";
import Location from "./pages/location/Location";
import BulkUpdate from "./pages/location/components/BulkUpdate";
import NotificationForm from './pages/notification/components/NotificationForm';
import Banners from 'pages/banners';
import CartReporting from 'pages/cartReporting';
import Wishlist from 'pages/wishlist/Wishlist';
import NotificationReporting from 'pages/notificationReporting/NotificationReporting';
import Faq from 'pages/faq/Faq';
import Predictions from 'pages/prediction/Prediction';
import PredictionCategoriesList from 'pages/prediction/PredictionCategoryList';
import PredictionCandidateList from 'pages/prediction/CandidateList';
import PredictionResult from 'pages/prediction/components/PredictionResult';
import ManageUser from "./pages/user/ManageUser";
import {hasPermissionToFeature} from "./helpers/helperFunctions";
import {
  FEATURE_ADD_FEATURE,
  FEATURE_BANNER, FEATURE_BLOG, FEATURE_CAMPAIGN,
  FEATURE_CAMPAIGN_REPORT,
  FEATURE_CART_REPORTING,
  FEATURE_DYNAMIC_UI,
  FEATURE_FOCUS_ITEM, FEATURE_GENERATE_LINKS,
  FEATURE_MANAGE_LOCATION,
  FEATURE_MANAGE_USER,
  FEATURE_NOTIFICATION,
  FEATURE_NOTIFICATION_REPORT,
  FEATURE_PAYMENT_VERIFICATION, FEATURE_PREDICTION, FEATURE_PRESCRIPTION,
  FEATURE_PRODUCT_FAQ,
  FEATURE_REMOTE_CONFIG, FEATURE_SHIFT,
  FEATURE_WISHLIST_REPORTING,
  FEATURE_REWARD_DASHBOARD,
  FEATURE_FULFILLMENT_OPERATOR,
} from "./pages/user/constants";
import Prescription from "./pages/prescription/Prescription";
import UserProfile from "./pages/user/UserProfile";
import AssignPermission from "./pages/permissions/AssignPermission";
import BlogList from "./pages/blogs/BlogList";
import CreateBlogCanvas from "./pages/blogs/CreateBlogCanvas";
import EditBlogCanvas from "./pages/blogs/EditBlogCanvas";
import CreatePrescriptions from "./pages/prescription/components/CreatePrescriptions";
import CustomerBalance from "./pages/reward/customerBalance/CustomerBalance";
import TransactionsList from "./pages/reward/transactions/TransactionsList";
import GenerateLinks from './pages/links/GenerateLinks'
import FulfillmentOperators from 'pages/fulfillmentOperators/fulfillmentOperators';


const AppRouter = () => {
  const isMobileViewSelected = useSelector((state) => state.dynamicUi.isPlatformMobile);
  const _user = useSelector((state) => state.authToken.user);


  return (
    <Router>
      <ScrollToTop/>
      <Sidebar isMobileViewSelected={isMobileViewSelected}/>


      <div className={isMobileViewSelected ? 'xl:ml-64' : ''}>
        <div style={{minHeight: "calc(100vh - 197px)"}}>

          <Routes>
            <Route element={<Dashboard/>} path="/"/>
            <Route element={<UserProfile/>} path="/profile"/>

            {hasPermissionToFeature(_user, FEATURE_MANAGE_USER) &&
              <Route element={<ManageUser/>} path="/users"/>}
            {hasPermissionToFeature(_user, FEATURE_ADD_FEATURE, true) &&
              <Route element={<AssignPermission/>} path="/assign-permissions"/>}
            {hasPermissionToFeature(_user, FEATURE_GENERATE_LINKS, true) &&
              <Route element={<GenerateLinks/>} path="/links"/>}
            {hasPermissionToFeature(_user, FEATURE_BLOG, ) &&
              <Route element={<BlogList/>} path="/blogs"/>}
            {hasPermissionToFeature(_user, FEATURE_BLOG) &&
              <Route element={<CreateBlogCanvas/>} path="/blogs/create"/>}
            {hasPermissionToFeature(_user, FEATURE_BLOG) &&
              <Route element={<EditBlogCanvas/>} path="/blogs/:blog_id"/>}



            {hasPermissionToFeature(_user, FEATURE_DYNAMIC_UI) &&
              <Route path="/dynamic-uis" element={<DynamicUiPage/>}/>}
            {hasPermissionToFeature(_user, FEATURE_BANNER) &&
              <Route path="/banners" element={<Banners/>}/>}

            {hasPermissionToFeature(_user, FEATURE_NOTIFICATION) &&
              <>
                <Route path="/notification" element={<Notification/>}/>
                <Route path="/notification/schedule/form" element={<NotificationForm/>}/>
                <Route path="/notification/bulk/form" element={<NotificationForm schedule={false}/>}/>
              </>
            }

            {hasPermissionToFeature(_user, FEATURE_NOTIFICATION_REPORT) &&
              <Route path="/notification-report" element={<NotificationReporting/>}/>}

            {hasPermissionToFeature(_user, FEATURE_FOCUS_ITEM) &&
              <Route path="/focus-items" element={<FocusItems/>}/>}

            {hasPermissionToFeature(_user, FEATURE_REMOTE_CONFIG) &&
              <Route path="/remote-config" element={<RemoteConfig/>}/>}

            {hasPermissionToFeature(_user, FEATURE_PAYMENT_VERIFICATION) &&
              <Route path="/payment-verification" element={<PaymentVerification/>}/>}

            {hasPermissionToFeature(_user, FEATURE_CAMPAIGN_REPORT) &&
              <Route path="/campaign-report" element={<CampaignReport/>}/>}

            {hasPermissionToFeature(_user, FEATURE_MANAGE_LOCATION) &&
              <>
                <Route path="/location-service" element={<Location/>}/>
                <Route path="/location-bulk" element={<BulkUpdate/>}/>
              </>}

            {hasPermissionToFeature(_user, FEATURE_CART_REPORTING) &&
              <Route path="/cart-list" element={<CartReporting/>}/>}

            {hasPermissionToFeature(_user, FEATURE_WISHLIST_REPORTING) &&
              <Route path="/wish-list" element={<Wishlist/>}/>}

            {hasPermissionToFeature(_user, FEATURE_PRODUCT_FAQ) &&
              <Route path="/faq" element={<Faq/>}/>}

            {hasPermissionToFeature(_user, FEATURE_PREDICTION) &&
              <>
                <Route path="/predictions" element={<Predictions/>}/>
                <Route path="/predictions/:campaign_id" element={<PredictionCategoriesList/>}/>
                <Route path="/predictions/:category_id/candidates" element={<PredictionCandidateList/>}/>
                <Route path="/predictions/:campaign_id/result" element={<PredictionResult/>}/>
              </>}

            {hasPermissionToFeature(_user, FEATURE_CAMPAIGN) &&
              <>
                <Route path="/campaigns" element={<NurseCampaign/>}/>
                <Route path="/campaigns/:campaign_id" element={<CampaignJobs/>}/>
              </>}

            {hasPermissionToFeature(_user, FEATURE_SHIFT) &&
              <Route path="/shifts" element={<Shifts/>}/>}

            {hasPermissionToFeature(_user, FEATURE_PRESCRIPTION) &&
              <>
                <Route path="/prescription" element={<Prescription/>}/>
                <Route path="/orders/:order_id" element={<CreatePrescriptions/>}/>
              </>


            }

            <Route path="/transactions" element={<TransactionsList/>}/>
            <Route path="/customers/:id/balance" element={<CustomerBalance/>}/>

            {hasPermissionToFeature(_user, FEATURE_FULFILLMENT_OPERATOR) &&
            <Route path='/fulfillment-operators' element={<FulfillmentOperators />} />
            }

            {/*<Route path="/consultation" element={<Consultation/>}/>*/}
            {/*<Route element={<PromotionalEvent/>} path="/events"/>*/}

            {/*<Route path="/events/:event_id" element={<EventDoctorAssociation/>}/>*/}
            {/*<Route path="/pharmacists" element={<Pharmacist/>}/>*/}
            {/*<Route path="/delivery" element={<Delivery/>}/>*/}
            {/*<Route path="/nurse" element={<Nurse/>}/>*/}
            {/*<Route path="/business" element={<Business/>}/>*/}
            {/*<Route path="/business/profile/:clinic_id" element={<BusinessProfile/>}/>*/}
            {/* <Route path="/banners" element={<Banner/>}/> */}

            <Route path="*" element={<Navigate to="/" replace/>}/>


          </Routes>
        </div>
        <Footer/>
      </div>
    </Router>
  );
};


export default AppRouter;

